import React, { useState } from "react";
import useAuth from "../hooks/useAuth";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as Logo } from "../assets/logo.svg";
import GoogleIcon from "../assets/google.png";
import AppleIcon from "../assets/Apple.png";
import "../styles/LoginPage.css";
import Loader from "../components/Loader";

const SignupPage: React.FC = () => {
  const navigate = useNavigate();
  const {
    handleSignup,
    error,
    setPassword,
    setConfirmPassword,
    setEmail,
    settName,
    name,
    email,
    password,
    confirmPassword,
    handleGoogleSignIn,
  } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    await handleSignup(e);
    setIsLoading(false);
  };

  return (
    <div className="login-container signup-container-color">
      <div className="login-card">
        <div className="logo-container">
          <Logo />
        </div>
        <form onSubmit={handleFormSubmit}>
          <input
            type="text"
            placeholder="Full Name"
            className="input-field"
            onChange={(e) => settName(e.currentTarget.value)}
            value={name}
          />
          <input
            type="email"
            placeholder="Email"
            className="input-field"
            onChange={(e) => setEmail(e.currentTarget.value)}
            value={email}
          />
          <input
            type="password"
            placeholder="Password"
            className="input-field"
            onChange={(e) => setPassword(e.currentTarget.value)}
            value={password}
          />
          <input
            type="password"
            placeholder="Confirm Password"
            className="input-field"
            onChange={(e) => setConfirmPassword(e.currentTarget.value)}
            value={confirmPassword}
          />

          {error && <p style={{ color: "black" }}>{error}</p>}
          {isLoading ? <Loader /> : ""}
          <div className="button-container">
            <button
              disabled={isLoading}
              type="submit"
              className="button button-primary"
            >
              Sign up
            </button>
            <button
              type="button"
              onClick={() => navigate("/")}
              className="button button-outline"
            >
              Sign in
            </button>
          </div>
        </form>
        {/* <button className="google-button" onClick={handleGoogleSignIn}>
          <img src={AppleIcon} alt="Apple Logo" className="google-icon" />
          Sign in with Apple
        </button> */}
        <button onClick={handleGoogleSignIn} className="google-button">
          <img src={GoogleIcon} alt="Google Logo" className="google-icon" />
          Sign in with Google
        </button>
      </div>
    </div>
  );
};

export default SignupPage;
